module.exports = __webpack_public_path__ + "media/images/como_funciona/choose-cards-b659fae2a828b4330e9a04402bde6668.png";